import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        height: 24,
        display:'flex',
        fontSize:8,
        fontStyle: 'bold',
        backgroundColor: '#e2e2e2',
        
    },
    header: {
        flexDirection: 'row',
        height: 24,
        alignItems: 'center',
        borderLeft: 1,
        paddingLeft: 5
    },
    itemcode: {
        minWidth: '15%',
    },
    ean: {
        minWidth: '20%',         
    },
    qty: {
        minWidth: '10%',
    },
    unit: {
        minWidth: '10%'
    },
    description: {
        minWidth: '15%',
    },
    dicount: {
        minWidth: '10%'
    },
    igv: {
        minWidth: '5%',
    },
    isc: {
        minWidth: '5%',
    },
    total: {
        minWidth: '10%',
    },
  });

  const TableHeader = () => (
    <div></div>
  );
  
  export default TableHeader